import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useUI } from '../../context/UIContext';
import { useTerritories } from '../../context/TerritoriesContext';
import { subscribeLeads } from '../../data/listeners/leads';
import { setLeadArchived } from '../../data/commands/leadCommands';
import {
  STAGE_COLOR, STAGE_BG, normalizeStage, leadValueOf,
} from '../../data/leadConstants';

const peso = (n) => `₱${Math.round(n).toLocaleString()}`;

// Archive tab (CRM revisions Task 2): archived Won/Lost leads, hidden from the
// active board/table but recoverable here via Un-archive.
export default function ArchivedLeads({ ownerFilter = '' }) {
  const { tenantId, role, territoryIds, profile, authUser } = useAuth();
  const { openLead } = useUI();
  const { terrLabel } = useTerritories();
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState('');
  const actor = { uid: authUser?.uid, name: profile?.name ?? profile?.email };

  useEffect(() => subscribeLeads(
    { tenantId, role, territoryIds },
    setLeads,
    (e) => setError(e.message || 'Could not load archive.'),
  ), [tenantId, role, territoryIds]);

  const rows = useMemo(
    () => leads.filter((l) => l.archived && (!ownerFilter || l.ownerUid === ownerFilter)),
    [leads, ownerFilter],
  );

  async function unarchive(lead, e) {
    e.stopPropagation();
    try {
      await setLeadArchived(lead.id, false, actor);
    } catch (err) {
      setError(err.message || 'Could not un-archive the lead.');
    }
  }

  return (
    <div>
      {error && <div className="form-error">{error}</div>}
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Business</th><th>Channel</th><th>Territory</th><th>Stage</th><th>Value ₱/mo</th><th /></tr>
          </thead>
          <tbody>
            {rows.map((l) => {
              const s = normalizeStage(l.stage);
              return (
                <tr key={l.id} className="click" onClick={() => openLead(l.id)}>
                  <td style={{ fontWeight: 'var(--font-semibold)' }}>{l.businessName}</td>
                  <td>{l.category}</td>
                  <td>{terrLabel(l.territoryId)}</td>
                  <td>
                    <span className="badge" style={{ background: STAGE_BG[s], color: STAGE_COLOR[s] }}>
                      <span className="dot" style={{ background: STAGE_COLOR[s] }} />{s}
                    </span>
                  </td>
                  <td>{peso(leadValueOf(l))}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-ghost btn-sm" onClick={(e) => unarchive(l, e)}>Un-archive</button>
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && (
              <tr><td colSpan={6} style={{ color: 'var(--color-fg-muted)', textAlign: 'center', padding: 'var(--space-8)' }}>No archived leads. Archive a Won or Lost deal to move it here.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
